import { Component, computed, input, output, signal } from '@angular/core';
import {
  GcButtonComponent,
  GcInputFieldComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-section-not-applicable-form',
  imports: [GcInputFieldComponent, GcButtonComponent, IpoTranslatePipe],
  templateUrl: './section-not-applicable-form.component.html',
  styleUrl: './section-not-applicable-form.component.scss',
})
export class SectionNotApplicableFormComponent {
  isSaving = input(false);

  confirmed = output<string>();
  cancelled = output<void>();

  readonly notApplicableReason = signal('');
  readonly canConfirmNotApplicable = computed<boolean>(
    () => this.notApplicableReason().trim().length > 0,
  );
  readonly isLoading = computed<boolean>(() => this.isSaving());

  onReasonChanged(notApplicableReason: string): void {
    this.notApplicableReason.set(notApplicableReason);
  }

  onConfirm(): void {
    if (!this.canConfirmNotApplicable() || this.isLoading()) {
      return;
    }
    this.confirmed.emit(this.notApplicableReason().trim());
  }
}
